import { connect } from "react-redux";
import {
  portfolios,
  portfolioPagination,
  getError,
  loading,
  portfoliosLoading,
} from "../../../store/selectors/portfolio.selector";
import {
  getPortFolio,
  createPortFolioRequest,
  updatePortFolioRequest,
  deletePortfoliosRequest,
} from "../../../store/actions/portfolio.actions";
import Portfolios from "./Portfolios";

const mapDispatchToProps = {
  getPortFolioRequest: getPortFolio,
  createPortFolioRequest,
  updatePortFolioRequest,
  deletePortfoliosRequest,
};

const mapStateToProps = (state) => {
  return {
    loading: loading(state),
    pageLoading: portfoliosLoading(state),
    allPortFolios: portfolios(state),
    pagination: portfolioPagination(state),
    error: getError(state),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Portfolios);
